import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {PricesGlossaryCard} from "../atoms/PricesGlossaryCard";
import {GLOSSARY_TERMS} from "../constants/glossary_terms";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {GlossaryTerm} from "../types/GlossaryTerm";
import {PricesCityViewSectionTracker} from "./PricesCityViewSectionTracker";

interface Props {
    terms?: GlossaryTerm[];
    location?: PricesCityAnalyticsLocation;
}

export const PricesGlossary = (props: Props) => {
    const {terms = GLOSSARY_TERMS, location} = props;

    return (
        <Container className={containerStyle}>
            {location && <PricesCityViewSectionTracker sectionName="glossary" location={location} />}

            <SlotSlider
                header={
                    <Text variant="headline_3" as="h2">
                        Słownik pojęć
                    </Text>
                }
                listLabel="Hasła słownika pojęć"
                prevLabel="Poprzednie hasła"
                nextLabel="Następne hasła"
                itemClassName={itemStyle}
            >
                {terms.map((term) => (
                    <PricesGlossaryCard key={term.title} term={term} />
                ))}
            </SlotSlider>
        </Container>
    );
};

const containerStyle = css({
    py: 4.5,

    md: {
        py: 8
    }
});

const itemStyle = css({
    width: "min(30rem, 83%)",

    sm: {
        width: "28rem"
    },

    md: {
        width: "30rem"
    }
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {PricesGlossaryCard} from "../atoms/PricesGlossaryCard";
import {GLOSSARY_TERMS} from "../constants/glossary_terms";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {GlossaryTerm} from "../types/GlossaryTerm";
import {PricesCityViewSectionTracker} from "./PricesCityViewSectionTracker";

interface Props {
    terms?: GlossaryTerm[];
    location?: PricesCityAnalyticsLocation;
}

export const PricesGlossary = (props: Props) => {
    const {terms = GLOSSARY_TERMS, location} = props;

    return (
        <Container className={containerStyle}>
            {location && <PricesCityViewSectionTracker sectionName="glossary" location={location} />}

            <SlotSlider
                header={
                    <Text variant="headline_3" as="h2">
                        Słownik pojęć
                    </Text>
                }
                listLabel="Hasła słownika pojęć"
                prevLabel="Poprzednie hasła"
                nextLabel="Następne hasła"
                itemClassName={itemStyle}
            >
                {terms.map((term) => (
                    <PricesGlossaryCard key={term.title} term={term} />
                ))}
            </SlotSlider>
        </Container>
    );
};

const containerStyle = css({
    py: 4.5,

    md: {
        py: 8
    }
});

const itemStyle = css({
    width: "min(30rem, 83%)",

    sm: {
        width: "28rem"
    },

    md: {
        width: "30rem"
    }
});
